let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("emJGv")).then(() => parcelRequire('2l8UK'));